import { useMembers } from '@/hooks/useMembers';
import { useAuth } from '@/hooks/useAuth';

/**
 * Returns the current caregiver's role on the given account, or null
 * while it loads / if the user isn't a member. Used to gate edit
 * controls on pages where preview is read-only.
 */
export function useMyRole(aid: string | null): 'admin' | 'caregiver' | null {
  const auth = useAuth();
  const { members } = useMembers(aid);
  if (auth.state !== 'signedIn') return null;
  const me = members.find((m) => m.id === auth.user.uid);
  return (me?.role as 'admin' | 'caregiver' | undefined) ?? null;
}
